import userSettings from "common/managers/userSettings";
import UserSettingNames from "common/enums/settings/UserSettingNames";
import topic from "common/managers/topic";
import Message from "common/enums/main/Message";
import loginProps from "common/managers/loginProps";
var result = {

    //Is accessible mode currently allowed
    _allow: false,

    //Has accessible mode been forced on when we don't have user settings (gateway)
    _forced: false,

    allow: function(allowAccessibleMode) {
        this._allow = !!allowAccessibleMode;
        this._update();
    },

    force: function() {
        $(document.body).toggleClass("accessibleMode");
        this._forced = true;
    },

    _update: function() {
        $(document.body).toggleClass("accessibleMode", this.isInAccessibleMode());
    },

    isInAccessibleMode: function() {
        return (this._allow && userSettings.getBoolean(UserSettingNames.ACCESSIBLE, this.getDefaultAccessibleMode())) || this._forced;
    },

    getDefaultAccessibleMode() {
        return !!loginProps.get().simplifiedScreenReaderMode;
    },
};
topic.subscribe(Message.USER_SETTING_CHANGED, $.proxy(result._update, result));
export default result;
